/* eslint-disable camelcase */
import React from "react";
import { createStyles, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles(() =>
  createStyles({
    alertContainer: {
      marginTop: "100px",
    },
  }));

export enum FormInfoType {
  Success = "Success",
  Warning = "Warning",
  Danger = "Danger",
  Info = "Info"
}

const mapTypeToClass = (type: FormInfoType | string) => `alert-${type.toLowerCase()}`;

export type FormInfoProps = {
  title: string,
  subtitle?: string,
  type: FormInfoType | string,
}
const FormInfo: React.FC<FormInfoProps> = (props) => {
  const classes = useStyles();

  return (
    <div className={`alert ${mapTypeToClass(props.type)} ${classes.alertContainer}`}>
      <Typography align="center" variant="h4">{props.title}</Typography>
      {props.subtitle && <Typography align="center" variant="subtitle1">{props.subtitle}</Typography>}
      <Typography variant="body1">{props.children}</Typography>
    </div>
  );
};

export default FormInfo;
